import i18nHelpers from '@/i18n/i18nHelpers'
import { loadLocales } from '@/utils/i18n.utils'

// Browser-locale detection + Spanish switching, matching the consumer.
// Also loads the "observer" locale namespace, which lives in its own file
// (src/pages/observer/locales/observer.{locale}.json) instead of the shared
// en.json/es.json, since it's only ever needed by this build.
export async function initLocale(): Promise<void> {
  try {
    const locale = i18nHelpers.getGuessDefaultLocale()
    if (i18nHelpers.currentLocale !== locale) {
      await i18nHelpers.switchLanguage(locale)
    }
    await loadLocales('observer')
  } catch (error) {
    console.error(
      'Failed to initialize observer locale. Falling back to "en".',
      error
    )
  }
}

let localeReadyPromise: Promise<void> | null = null

// Memoized so bootstrap (fire-and-forget) and the router (awaited) share
// the same locale-resolution promise, so a route's `loadLocales` call never
// runs before locale is switched. switchLanguage() dynamically imports the
// target locale's JSON and awaits nextTick, so this guard is still needed
// even though feature flags now resolve synchronously.
export function ensureObserverLocaleReady(): Promise<void> {
  if (!localeReadyPromise) {
    localeReadyPromise = initLocale()
  }

  return localeReadyPromise
}
